import React from "react";
export default function SocialMediaNotSupported(props: any) {
    return (
        <>
            <div className="dialog-header" style={{ display: "flex" }}>
                <div className="content-sub-title text-align-center">
                    <div style={{ fontSize: "35px", paddingRight: "0.5rem" }}>
                        <em className="las la-exclamation-circle "></em>
                    </div>
                </div>
                <div className="box-title-text">
                    <h2 className="box-title social-media-dialog-title" style={{ paddingRight: "2rem" }}>
                        Can’t connect social media accounts
                    </h2>
                </div>
            </div>
            <div className="dialog-body margin-left-s">
                <div className="row">
                    <p>We can’t connect your social media accounts on Safari right now. Please try again using a different browser.</p>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row justify-center">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={props.closeDialog}>
                            <span className="btn-text">Got it</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
